import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import logo from "../goeei.png";
import { loginAPI } from "../services/login/actions";
import "../styles/LoginForm.scss";

function Login(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const identifyInfo = useSelector((state) => state.identify.identifyInfo);

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    props.loginAPI(username, password);
  };

  if (props.userId) {
    navigate("/menu");
  }

  return (
    <div
      className="LoginFormWrapper"
      style={{ backgroundImage: `url(${identifyInfo.background})` }}
    >
      <div className="LoginFormBackground"></div>
      <div className="LoginForm fadeIn">
        <img src={logo} alt="Logo" className="LoginFormLogo" />
        <form onSubmit={handleSubmit}>
          <p>Welkom bij Goei Eete!</p>
          <input
            className="LoginFormInput"
            placeholder="Gebruikersnaam"
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
          <input
            className="LoginFormInput"
            type="password"
            placeholder="Wachtwoord"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input className="LoginFormSubmit" type="submit" value="Inloggen" />
        </form>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userId: state.login.login_data.user_id,
  };
}

export default connect(mapStateToProps, {
  loginAPI,
})(Login);
